<template>
  <div id="app">
    <preloader v-if="visiblePreloader"></preloader>
    <v-app id="inspire" dark class="app height-100" v-if="publicPage">
      <v-content class="content-main height-100 scroll-y">
        
        <div class="height-100">
          <router-view></router-view>
        </div>
      </v-content>
      <!-- Go to top -->
      <app-fab></app-fab>
    </v-app>
    <v-app dark v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </v-app>  
    <snackbar
      :show="snackbarVisible"
      :timeout="snackbarTimeout"
      :text="snackbarTitle"
      :color="snackbarColor">
    </snackbar>
  </div>
</template>

<script>
    import AppFab from './components/AppFab'
    import {mapGetters, mapMutations} from "vuex";
    import axios from './plugins/axios'
    import preloader from './components/widgets/preloader'
    import snackbar from './components/widgets/snackbar'

    export default {
        name: 'App',
        components: {
            AppFab,
            preloader,
            snackbar
        },
        data() {
            return {
                dark: true, 
                mainRouteChange: false,
                publicPage: true,
                visiblePreloader: false,
                toggleSidebar: false,
                expanded: true,
                rightDrawer: false,
                // snackbar: {
                //   show: false,
                //   text: '',
                //   color: '',
                // }
            }
        },
        computed: {
            ...mapGetters(["preloaderVisible", "snackbarVisible", "snackbarTitle", "snackbarTimeout", "snackbarColor"]),
        },
        methods: {
            ...mapMutations(["changePreloaderVisible"]),
        },
        watch: {
            '$route'(to, from) {
                this.mainRouteChange = !this.mainRouteChange;
                this.publicPage = to.meta.public;
            },
            preloaderVisible(newVal) {
                console.log('Preloader: ', newVal)
                this.visiblePreloader = newVal;
            }
        },
        created() {
            axios.interceptors.response.use(undefined, err => {
                return new Promise((resolve, reject) => {
                    if (err.response.status === 401) {
                        console.log('Failed with session: ', process.$session);
                        process.$session = '';
                        console.log('Unauth!')
                        this.userIsLogined = false;
                        this.$router.push('/')
                        this.$store.commit('changePreloaderVisible', false)
                    }
                     console.log('Refresh login error: ', err)
                    throw err;
                });
            });
        },
    }
</script>

<style>
#app {
    background: #303030 !important;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue